import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { TranslateModule, TranslatePipe } from '@ngx-translate/core';
import { FilterViewLayoutModule } from '@go-modules/components/filter-view-layout/filter-view-layout.module';
import { GoMaterialModule } from '@go-modules/go-material.module';
import { NgxFolderTableViewComponent } from './folders-table-view/folders-table-view.component';
import { NgxFoldersViewComponent } from './folders-view.component';
import { NgxZeroStateModule } from '@go-modules/components/zero-state/zero-state.module';
import {
	FoldersZeroStateComponent
} from '@dashboard/app/components/folders-view/folders-zero-state/folders-zero-state.component';
import { ReactiveFormsModule } from '@angular/forms';
import { GoSelectModule } from '@go-modules/directives/go-select/go-select.module';
import {
	DataSourceZeroStateModule
} from '@go-modules/components/data-source-zero-state/data-source-zero-state.module';
import { DotIndicatorModule } from '@go-modules/components/dot-indicator/dot-indicator.module';
import { FoldersGridViewModule } from '@dashboard/app/components/folders-view/folders-grid-view/folders-grid-view.module';
import { OutsideClickModule } from '@go-modules/directives/outside-click';
import { MenuModule } from '@go-modules/components/menus/menu/menu.module';
import { CommentIndicatorModule } from '@go-modules/components/comment-indicator/comment-indicator.module';
import { AlphabeticalByKeyPipeModule } from '@go-modules/pipes/alphabetical/alphabetical-by-key-pipe.module';
import { OrgContextMenuModule } from '@dashboard/app/components/folders-view/org-context-menu/org-context-menu.module';
import { FolderMenuModule } from '@go-modules/components/menus/folder-menu/folder-menu.module';
import { FolderCardModule } from '@dashboard/app/components/folders-view/folder-card/folder-card.module';
import { BadgeModule } from '@go-modules/components/badge/badge.module';
import { ToggleGridListViewComponent } from '@go-modules/components/toggle-grid-list-view/toggle-grid-list-view.component';

@NgModule({
	imports: [
		CommonModule,
		FilterViewLayoutModule,
		TranslateModule,
		GoMaterialModule,
		NgxZeroStateModule,
		FolderMenuModule,
		ReactiveFormsModule,
		GoSelectModule,
		DataSourceZeroStateModule,
		DotIndicatorModule,
		FolderCardModule,
		FoldersGridViewModule,
		OutsideClickModule,
		MenuModule,
		CommentIndicatorModule,
		AlphabeticalByKeyPipeModule,
		OrgContextMenuModule,
		BadgeModule,
		ToggleGridListViewComponent
	],
	declarations: [
		NgxFoldersViewComponent,
		NgxFolderTableViewComponent,
		FoldersZeroStateComponent
	],
	exports: [
		NgxFoldersViewComponent,
		NgxFolderTableViewComponent,
		FoldersZeroStateComponent
	],
	providers: [
		TranslatePipe
	]
})
export class NgxFoldersViewModule {}
